import { LegalDocumentPage } from "components/LegalDocumentPage";
import {
  privacyPolicyMeta,
  privacyPolicyIntro,
  privacyPolicySections,
} from "content/privacyPolicyContent";

export default function PrivacyPolicyPage() {
  return (
    <LegalDocumentPage
      meta={privacyPolicyMeta}
      intro={privacyPolicyIntro}
      sections={privacyPolicySections}
      helmetDescription="Fortify Portal, Inc. Privacy Policy — how we collect, use, and protect your personal information under PIPEDA."
    />
  );
}
